{
    "ManageCustomRoles_Title": "Benutzerdefinierte Rollenvorlage hinzufügen",
    "ManageCustomRoles_Role_Name": "Name der Rollenvorlage",
    "ManageCustomRoles_Description": "Beschreibung",
    "ManageCustomRoles_Cancel": "Abbrechen",
    "ManageCustomRoles_Help": "Hilfe",
    "ManageCustomRoles_Save": "Speichern Sie",
    "NAME": "ManageCustomRoles"
}